import PartnerBanks from "@/components/landing/PartnerBanks";
import { useCallback } from "react";
import { LOAN_TYPES } from "@/constants/loanTypes";
import SEO from "@/components/common/SEO";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

import { ccLimit } from "@/data/loans";

const CCLimit = () => {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...ccLimit.seo} />
      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...ccLimit.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...ccLimit.overview} />

        <LoanBenefits {...ccLimit.benefits} />

        <LoanTypes {...ccLimit.types} />

        <LoanEligibility
          {...ccLimit.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...ccLimit.documents} />

        <LoanProcess {...ccLimit.process} />

        <WhyMoneyMart {...ccLimit.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...ccLimit.faq} />

        <LoanCTA {...ccLimit.cta} onApply={scrollToLeadForm} />

        <LeadFormSection {...ccLimit.leadForm} loanType="CC_LIMIT" />
      </LoanLayout>
    </>
  );
};

export default CCLimit;
